import { useAutoFocusField } from 'commons/hooks/use-auto-focus-field.hook';

const FIELD_SELECTOR = 'owc-select-dropdown, owc-datepicker, owc-input';

const isNestedFieldInput = (element: Element): boolean =>
    element.tagName === 'OWC-INPUT' && !!element.closest('owc-select-dropdown, owc-datepicker');

const resolveFirstEnabledFieldInput = (container: HTMLOwcModalDialogElement): HTMLElement | null => {
    const firstField = Array.from(
        container.querySelectorAll<HTMLElement & { disabled?: boolean }>(FIELD_SELECTOR)
    ).find((field) => !isNestedFieldInput(field) && !field.disabled);

    return firstField?.querySelector<HTMLElement>('input') ?? null;
};

interface UseModalAutoFocusParams {
    loading?: boolean;
    initialDelay?: number;
}

export const useModalAutoFocus = ({ loading, initialDelay }: UseModalAutoFocusParams) =>
    useAutoFocusField<HTMLOwcModalDialogElement>({
        loading,
        initialDelay,
        resolveTarget: resolveFirstEnabledFieldInput,
    });
